import LocomotiveScroll from "locomotive-scroll";

export default class {
  scrolled = false;
  lastScrollTop = 0;

  constructor() {
    this.hamburger();
    this.replaceableLogo();
    this.closeSubMenu();
    this.toggleNavigationOnScroll();
  }

  hamburger() {
    const hamburger = document.querySelector(".js--hamburger");
    if (!hamburger) return;

    hamburger.addEventListener("click", (e) => {
      e.preventDefault();
      document.body.classList.toggle("is-hamburger-open");

      if (document.body.classList.contains("is-hamburger-open")) {
        window.locomotiveScrollInstance.destroy();
      } else {
        window.locomotiveScrollInstance = new LocomotiveScroll();
      }
    });
  }

  /**
   * Replace the logo with the secondary logo on scroll
   * when you scroll past 10 px from top add a class 'scrolled' to the header
   */
  replaceableLogo() {
    const header = document.querySelector(".SiteHeader");
    if (!header) return;

    // add scroll event listener
    window.addEventListener("scroll", () => {
      if (window.scrollY > 10 && !this.scrolled) {
        this.scrolled = true;
        header.classList.add("scrolled");
      }
      if (window.scrollY < 10 && this.scrolled) {
        this.scrolled = false;
        header.classList.remove("scrolled");
      }
    });

    // trigger scroll event
    window.dispatchEvent(new Event("scroll"));
  }

  closeSubMenu() {
    // on document click check if .js--close-sub-menu class, if it is then do the action
    document.addEventListener("click", (e) => {
      if (e.target.closest(".js--close-sub-menu")) {
        e.preventDefault();
        jQuery(".max-mega-menu").data("maxmegamenu").hideAllPanels();
      }
    });
  }

  toggleNavigationOnScroll() {
    const header = document.querySelector(".SiteHeader");
    if (!header) return;

    window.addEventListener("scroll", () => {
      const currentScrollTop = window.scrollY;

      if (currentScrollTop > this.lastScrollTop) {
        header.classList.add("is-up");
        // header.style.top = "-100px"; // Hide the header
      } else {
        // header.style.top = "0"; // Show the header
        header.classList.remove("is-up");
      }

      this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
    });
  }
}